import { makeStyles } from 'tss-react/mui';

/** Shared page frame for every fulfilled service Activity tab. */
export function ActivityTabLayout({ children }: { children: React.ReactNode }) {
  const { classes } = useStyles();
  return (
    <div className={classes.layout}>
      <h1 className={classes.title}>Activity</h1>
      {children}
    </div>
  );
}

const useStyles = makeStyles({ name: { ActivityTabLayout } })(() => ({
  layout: {
    padding: '30px 40px',
    width: '100%',
  },
  title: {
    fontFamily: 'Montserrat',
    fontSize: 19,
    fontWeight: 700,
    letterSpacing: 0,
    margin: '0 0 24px',
  },
}));
